
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/novosti",
      function () {
        return require("private-next-pages/novosti/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/novosti"])
      });
    }
  